<template>
  <div class="report-upgrade-card">
    <div class="report-upgrade-card__icon">
      <svg
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#3ecfb4"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
    </div>
    <h3 class="report-upgrade-card__title">{{ title }}</h3>
    <p class="report-upgrade-card__desc">{{ desc }}</p>
    <router-link :to="{ name: 'plans' }" class="report-upgrade-card__btn"
      >Ver planes</router-link
    >
  </div>
</template>

<script>
export default {
  name: "ReportUpgradeCard",
  props: {
    title: String,
    desc: String,
    feature: String
  }
};
</script>

<style scoped>
.report-upgrade-card__btn {
  display: inline-block;
  background: #3ecfb4;
  color: #fff !important;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 20px;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.15s;
}
.report-upgrade-card__btn:hover {
  background: #2db89f;
  color: #fff !important;
  text-decoration: none;
}
</style>
